import { createElement, FC } from "react";
import styled from "styled-components";

type child = number | string | JSX.Element;

interface IParagraph {
  children: child | child[];
  size?: 14 | 16 | 18 | 20 | number;
  lineHeight?: string;
  weight?: number;
  tag?: string;
  color?: string;
  className?: string;
}

interface IStyledParagraph {
  tag: string;
  size: 14 | 16 | 18 | 20 | number;
  lineHeight: string;
  color: string;
  weight: number;
  children: child | child[];
  className?: string;
}

const ParagraphWithTag = (props: IStyledParagraph) =>
  createElement(props.tag, props, props.children);

const StyledParagraph = styled((props) =>
  ParagraphWithTag(props)
)<IStyledParagraph>`
  font-family: var(--base-font);
  font-weight: ${(props) => props.weight};
  color: ${(props) => `var(--${props.color})`};
  transition: 0.4s;
  font-size: ${(props) => `${props.size}px`};
  line-height: ${(props) => `${props.lineHeight}`};
`;
const Paragraph: FC<IParagraph> = ({
  children,
  size = 14,
  weight = 400,
  lineHeight = "1.26",
  tag = "p",
  color = "text",
  className,
}) => {
  return (
    <StyledParagraph
      size={size}
      lineHeight={lineHeight}
      className={className}
      tag={tag}
      color={color}
      weight={weight}
    >
      {children}
    </StyledParagraph>
  );
};

export default Paragraph;
